import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BookingWidget from './BookingWidget'; // <--- O NOSSO NOVO COMPONENTE
import { ThemeProvider } from './context/ThemeContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// --- MODO DE SEGURANÇA / MANUTENÇÃO ---
// Mude para 'true' para BLOQUEAR o acesso público imediatamente.
const MAINTENANCE_MODE = false;

// Ecrã de Bloqueio (Simples e Leve)
const SecurityScreen = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#f8fafc',
    color: '#1e293b',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    padding: '20px',
    textAlign: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999
  }}>
    <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🛡️</div>
    <h1 style={{ fontSize: '2rem', fontWeight: '800', marginBottom: '1rem', color: '#0f172a' }}>
      Manutenção de Segurança
    </h1>
    <p style={{ maxWidth: '600px', lineHeight: '1.6', fontSize: '1.1rem', color: '#475569', marginBottom: '2rem' }}>
      O site encontra-se temporariamente indisponível para uma verificação técnica de segurança programada.
      <br />
      Agradecemos a compreensão. Voltaremos em breve.
    </p>
    <div style={{ fontSize: '0.85rem', color: '#94a3b8', borderTop: '1px solid #e2e8f0', paddingTop: '1rem', width: '100%', maxWidth: '300px' }}>
      Vintage Praia &copy; 2025
    </div>
  </div>
);

// --- LÓGICA DE DECISÃO HÍBRIDA ---

// 1. Tenta encontrar o alvo do WordPress
const widgetTarget = document.getElementById('vintage-booking-widget');

if (widgetTarget) {
  // CASO A: Estamos no WordPress!
  // Renderizamos APENAS o Widget, mas envolvido no ThemeProvider para ter as cores certas.
  const root = ReactDOM.createRoot(widgetTarget);
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <BookingWidget />
      </ThemeProvider>
    </React.StrictMode>
  );

} else {
  // CASO B: Estamos no Site React Completo (localhost ou App)
  const rootTarget = document.getElementById('root');
  
  if (rootTarget) {
    const root = ReactDOM.createRoot(rootTarget);

    if (MAINTENANCE_MODE) {
      root.render(<SecurityScreen />);
    } else {
      root.render(
        <React.StrictMode>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </React.StrictMode>
      );
    }
  }
}

// Service Worker (Mantém a PWA a funcionar)
serviceWorkerRegistration.unregister();